export default __webpack_public_path__ + "static/teresa-45f782d327f07cb95010c526392c05c4.jpg";